<template>
  <div class="home-content-page-v" id="result-page">
    <div class="dialog-content">
      <div class="choose-show-cases dialog-choose-show-cases">
        <el-checkbox-group v-model="compareCasesName" size="large" fill="#324057" text-color="#a4aebd" :min="1" :max="3">
          <el-checkbox-button v-for="caseOne in casesEle" :label="caseOne.name" :disabled="caseOne.status !== 30" :key="caseOne.name">{{caseOne.name}}</el-checkbox-button>
        </el-checkbox-group>
      </div>
      <case-compare-table :caseDatas="compareCases" :table_height="22"></case-compare-table>
    </div>
  </div>
</template>

<script>
  import CaseCompareTable from '../../components_bit/CaseCompareTable'
  export default {
    components: {
      CaseCompareTable
    },
    computed: {
      eleStatus: {
        get () {
          return this.$store.getters.eleStatus
        }
      },
      compareCasesName: {
        get () {
          return this.$store.getters.compareCasesName
        },
        set (value) {
          this.$store.dispatch('setCompareCasesName', value)
        }
      },
      casesEle: {
        get () {
          return this.$store.getters.casesEle
        }
      },
      compareCases: {
        get () {
          let vm = this
          let newData = []
          if (this.casesEle) {
            this.casesEle.forEach(function (item, index) {
              if (vm.compareCasesName.indexOf(item.name) > -1) {
                item.index = index
                newData.push(item)
              }
            })
          }
          return newData
        }
      }
    },
    created () {
      if (this.eleStatus < 10) {
        this.$router.push({name: 'ele_import'})
      }
    },
    mounted () {
      if (this.compareCasesName.length === 0) {
        let newData = []
        this.casesEle.forEach(function (item) {
          if (item.status === 30) {
            newData.push(item.name)
          }
        })
        this.compareCasesName = newData.slice(0, 2)
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .case-db {
    color: #a4aebd;
    background-color: #324057;
    line-height: 2.5rem;
    padding: 0 1rem;
    border-radius: 0.3rem;
  }
  .dialog-choose-show-cases {
    margin-bottom: 2rem;
  }
  .home-content-page-v {
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .dialog-content {
    display: flex;
    flex-direction:column;
  }
  .show-detail {
    align-self: flex-end;
    flex: 0.5 !important;
    display: flex;
    align-items: center;
    a {
      border-radius: 0.2rem;
      background-color: rgb(50, 64, 87);
      color: #fff;
      font-size: 0.8rem;
      height: 1.2rem;
      padding: 0.1rem 0.5rem;
    }
  }
  .data-title {
    width: 100%;
    font-size: 1.3rem;
    color: @bak-color-2;
  }
  .data-chat {
    height: 22rem;
    width: 100%;
    margin-bottom: 1rem;
  }
  .data-chat-2 {
    height: 22rem;
    display: flex;
    margin-bottom: 1rem;
  }
  .case-info {
    display: flex;
    flex: 1;
    padding: 1rem;
    margin:1rem;
    border-radius: 1rem;
    color: #666;
    flex-direction:column;
    border: 1px solid #aaa;
  }
  .case-info-one {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  .map-page-pre {
    width: 40%;
  }
  .map-page-line {
    width: 100%;
  }
  .map-page {
    height: 22rem;
  }
  .choose-show-cases {
    display: flex;
    min-height: 3rem;
    justify-content:space-between;
    align-items: center;
  }
  .ele-result-list {
    display: block;
  }
  .ele-result-one {
    background: #fff;
    border-radius: 1rem;
    padding: 1rem;
    margin-top: 1rem;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction:column;
  }
</style>



// WEBPACK FOOTER //
// ele_compare.vue?55cc4d46